<div class="container d-flex align-items-center justify-content-center">
  <div class="col-md-10 col-lg-8 col-xl-6 p-0">
    <div class="card">
      <div class="card-header">
        <picture>
          <source
            srcset="/resources/images/finquery-logo-white.png"
            media="(min-width: 900px)"
          />
          <img
            src="/resources/images/finquery-logo-white.png"
            alt="FinQuery"
            class="icon-banner"
            height="32"
          />
        </picture>
      </div>
      @if (isRealmConnection) {
        <div>
          <form [formGroup]="form" (validSubmit)="onConnectClick()">
            <div class="card-body">
              <h3>Let's get you set up to use QuickBooks</h3>
              <p class="card-text">
                Select one of your {{ 'organisations' | ize }} below to link
                with your QuickBooks company.
              </p>

              <app-select-integration-register [formGroup]="form">
              </app-select-integration-register>
            </div>
            <div class="card-footer">
              <div class="d-flex justify-content-between">
                <button
                  type="button"
                  class="btn btn-outline text-start"
                  [disabled]="form.disabled"
                  (click)="onCancelClick()"
                >
                  Cancel
                </button>
                @if (!isConnecting) {
                  <button type="submit" class="btn btn-primary">Connect</button>
                } @else {
                  <button class="btn btn-primary" type="button" disabled>
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Connecting&hellip;
                  </button>
                }
              </div>

              <hr />
              <div class="text-sm mt-3">
                &copy; {{ currentYear }} FinQuery, LLC
              </div>
            </div>
          </form>
        </div>
      } @else {
        <app-loading></app-loading>
      }
    </div>
  </div>
</div>
